@file:kotlin.js.JsExport
package com.narbase.letsgo.web.dto.config

class TimeoutIncentiveConfigDto (
    val amount: Double,
    val activationTimeOffsetInSecs: Int,
    val maxRidePrice: Double?,
    val minRidePrice: Double?,
    val passengerMessage: String?,
    val isEnabled: Boolean
)